import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { API_URL, pathHomePage, pathTherapistHome, pathPatientHome, pathRegister } from "../../config/constants";
import VippstarLogo from "../../assets/vippstar_logo.png";
import {
  Container, Card, LogoWrapper, CardTitle, Form,
  Field, Label, Input, SubmitButton, ErrorMsg, LinkText,
} from "./styles";

const Login = () => {
  const history = useHistory();
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const text = await res.text();
      let data;
      try { data = JSON.parse(text); } catch { throw new Error("Server error. Please try again."); }
      if (!res.ok) throw new Error(data.error);
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      if (data.user.role === "therapist") history.push(pathTherapistHome);
      else if (data.user.role === "patient") history.push(pathPatientHome);
      else history.push(pathHomePage);
    } catch (err) {
      setError(err.message || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Card>
        <LogoWrapper>
          <img src={VippstarLogo} alt="Vippstar" style={{ width: 90 }} />
        </LogoWrapper>
        <CardTitle>Sign in</CardTitle>
        <Form onSubmit={handleSubmit}>
          <Field>
            <Label>Username</Label>
            <Input
              type="text"
              name="username"
              placeholder="Enter your username"
              value={form.username}
              onChange={handleChange}
              required
            />
          </Field>
          <Field>
            <Label>Password</Label>
            <Input
              type="password"
              name="password"
              placeholder="••••••••••••"
              value={form.password}
              onChange={handleChange}
              required
            />
          </Field>
          {error && <ErrorMsg>{error}</ErrorMsg>}
          <SubmitButton type="submit" disabled={loading}>
            {loading ? "Signing in..." : "Sign in"}
          </SubmitButton>
        </Form>
        <LinkText>
          Don't have an account? <Link to={pathRegister}>Register</Link>
        </LinkText>
      </Card>
    </Container>
  );
};

export default Login;
